import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import { FadeInUp, SlideIn } from '../components/Animations';

export default function About() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const values = t('aboutPage.values', { returnObjects: true });

  return (
    <>
      <SEO
        title={isRTL ? 'وجود لينك | من نحن' : 'Wojod Link | About Us'}
        description={t('aboutPage.description')}
      />

      {/* ── Page Hero ── */}
      <section className="page-hero">
        <div className="container">
          <FadeInUp>
            <div className="page-hero-content">
              <span className="section-label">{t('aboutPage.label')}</span>
              <h1 className="page-title">{t('aboutPage.title')}</h1>
              <p className="page-description">{t('aboutPage.description')}</p>
            </div>
          </FadeInUp>
        </div>
      </section>

      {/* ── Story ── */}
      <section className="about-story">
        <div className="container">
          <div className="story-grid">
            <SlideIn direction={isRTL ? 'right' : 'left'}>
              <div className="story-image">
                <i className="fas fa-rocket" />
              </div>
            </SlideIn>

            <SlideIn direction={isRTL ? 'left' : 'right'} delay={0.15}>
              <div className="story-content">
                <span className="section-label">{t('aboutPage.storyTitle')}</span>
                <h2 className="section-title">{t('aboutPage.storyTitle')}</h2>
                <p className="section-description">{t('aboutPage.storyP1')}</p>
                <p className="section-description">{t('aboutPage.storyP2')}</p>
                <p className="section-description">{t('aboutPage.storyP3')}</p>
              </div>
            </SlideIn>
          </div>
        </div>
      </section>

      {/* ── Values ── */}
      <section className="values-section">
        <div className="container">
          <FadeInUp>
            <div className="section-header text-center">
              <span className="section-label">{t('aboutPage.valuesLabel')}</span>
              <h2 className="section-title">{t('aboutPage.valuesTitle')}</h2>
              <p className="section-description">{t('aboutPage.valuesDescription')}</p>
            </div>
          </FadeInUp>

          <div className="values-grid">
            {values.map((val, i) => (
              <FadeInUp key={i} delay={i * 0.1}>
                <div className="value-card">
                  <div className="value-icon">
                    <i className={val.icon} />
                  </div>
                  <h3 className="value-title">{val.title}</h3>
                  <p className="value-text">{val.text}</p>
                </div>
              </FadeInUp>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-section">
        <div className="container">
          <FadeInUp>
            <div className="cta-content">
              <h2>{t('aboutPage.ctaTitle')}</h2>
              <p>{t('aboutPage.ctaDescription')}</p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-accent">
                  {t('aboutPage.ctaBtn')} <i className={`fas fa-arrow-${isRTL ? 'left' : 'right'}`} />
                </Link>
              </div>
            </div>
          </FadeInUp>
        </div>
      </section>
    </>
  );
}
